import {
   AiAssistantBudgetSummary,
   HealthcareProviderAiAssistantTokenPackage,
} from '@dreryk/egabinet-ai-assistant-frontend-api';

import { TranslatableText } from '@dreryk/react-common';

import { aiAssistantSettingsPanelTranslationKeys } from '../translations';

const t = aiAssistantSettingsPanelTranslationKeys;

export type AiAssistantTokenUsage = Readonly<{ balance: number; limit: number; usage: number }>;

const toTime = (date: Date): number => new Date(date).getTime();

const isInForce = (tokenPackage: HealthcareProviderAiAssistantTokenPackage, now: number): boolean =>
   toTime(tokenPackage.validFrom) <= now && (tokenPackage.validTo === undefined || toTime(tokenPackage.validTo) >= now);

const isMonthly = (tokenPackage: HealthcareProviderAiAssistantTokenPackage): boolean => tokenPackage.type === 'MONTHLY';

const byLatestValidFrom = (
   left: HealthcareProviderAiAssistantTokenPackage,
   right: HealthcareProviderAiAssistantTokenPackage
): number => toTime(right.validFrom) - toTime(left.validFrom);

export const findCurrentPlan = (
   tokenPackages: HealthcareProviderAiAssistantTokenPackage[],
   now: number = Date.now()
): HealthcareProviderAiAssistantTokenPackage | undefined => {
   const latestFirst = [...tokenPackages].sort(byLatestValidFrom);
   const inForce = latestFirst.filter((tokenPackage) => isInForce(tokenPackage, now));

   return inForce.find(isMonthly) ?? inForce[0] ?? latestFirst.find(isMonthly) ?? latestFirst[0];
};

export const formatCurrentPlan = (currentPlan: HealthcareProviderAiAssistantTokenPackage): TranslatableText =>
   currentPlan.variant ? t.variantMap[currentPlan.variant] : currentPlan.name;

export const toTokenUsage = (budgetSummary: AiAssistantBudgetSummary): AiAssistantTokenUsage => {
   const balance = Math.min(0, budgetSummary.debtTokens);
   return { balance: balance, limit: budgetSummary.grantedTokens, usage: budgetSummary.usedTokens - balance };
};
